module.exports = __webpack_public_path__ + "img/zan.0d1f4b60.png";